import { useCallback } from 'react'
import app from 'common/lib/App'
import { ModalData } from 'common/components/modals/types'
import useModalAction from 'common/hooks/useModalAction'
import { trackFailDialogModal } from './trackUtils'

type Status = 'unauthorized' | 'serverError'

const MODAL_DATA: Record<string, ModalData> = {
  unauthorized: {
    isOpen: true,
    modal: 'action',
    closeText: 'กลับ',
    actionText: 'สมัครบัญชีใหม่',
    content: {
      title: 'อีเมลหรือเบอร์โทรศัพท์ไม่ถูกต้อง',
      description:
        'Wongnai Owner Connect เป็นบริการเสริม สำหรับ Wongnai Merchant App (RMS) คุณจำเป็นต้องมีบัญชีของ Merchant App ก่อน',
    },
  },
  serverError: {
    isOpen: true,
    modal: 'submit',
    submitText: 'ตกลง',
    content: {
      title: 'เกิดข้อผิดพลาดบางอย่าง กรุณาลองใหม่อีกครั้ง',
      description: 'หรือติดต่อฝ่ายบริการลูกค้า 02-821-5788',
    },
  },
}

export const useModal = () => {
  const { updateModalData, resetModalData } = useModalAction()

  const setErrorStatus = useCallback((status: Status) => {
    if (status === 'unauthorized') {
      updateModalData({
        ...MODAL_DATA.unauthorized,
        onClickClose: resetModalData,
        onClickAction: () => {
          resetModalData()
          app.deepLinkTo('/login')
        },
        onImpression: trackFailDialogModal,
      })
    } else if (status === 'serverError') {
      updateModalData({
        ...MODAL_DATA.serverError,
        onClickClose: resetModalData,
      })
    } else {
      resetModalData()
    }
  }, [])

  return { setErrorStatus }
}
